import React from "react";
import { Grid, FormControlLabel, Button, Checkbox } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import FormulaDataType from "./common/FormulaDataType";
import ExpressionFormulaPopup from "./ExpressionFormulaPopup";

function ExpressionFormulaColumnConfig(props) {
  const { values, handleChange, setFieldValue, store } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const setReviseButtonRef = React.useCallback(
    (node) => {
      if (node !== null && !values.options.formula) {
        setAnchorEl(node);
      }
    },
    [values.options.formula]
  );

  React.useEffect(() => {
    setFieldValue("options.apply_formula", values.options["apply_formula"]);
    if (values.options.formula_column) {
      return;
    }
  }, [setFieldValue, values.options.formula_column]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Button
          ref={setReviseButtonRef}
          onClick={(e) => {
            if (!values.column_name) {
              return Ext.Msg.alert("Error", "Please enter column name");
            }
            setAnchorEl(e.target);
          }}
          variant="outlined"
        >
          Revise
        </Button>
        <ExpressionFormulaPopup
          anchorEl={anchorEl}
          formula={values.options.formula ?? ""}
          columnTypeId={values.column_type_id}
          onClose={() => setAnchorEl(null)}
          onSave={(formula) => {
            if (!formula) {
              window.appStore.notificationStore.showNotification(
                "Please enter formula",
                "error"
              );
              return;
            }
            setFieldValue("options.formula", formula);
            setAnchorEl(null);
          }}
          columnName={values.column_name}
          validateExpressionFormula={store.validateExpressionFormula}
          store={store}
        />
      </Grid>
      <FormulaDataType {...props} />
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              name={`options.apply_formula`}
              checked={values.options["apply_formula"]}
              onChange={handleChange}
            />
          }
          label={"Apply formula for all rows in current sheet"}
        />
      </Grid>
    </React.Fragment>
  );
}

export default inject(({ store: appStore }) => ({
  // validateExpressionFormula: appStore.addColumnStore.validateExpressionFormula,
}))(observer(ExpressionFormulaColumnConfig));
